import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class ICCookieService {
  constructor(private cookieService: CookieService) {}

  getCookie(cookieName: string): string {
    return this.cookieService.get(cookieName);
  }
}
